import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class KaiziqManageConnectionService {

    constructor() {
        
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.KAIZIQ_MANAGE = '/api/kaiziq/manage';
    
        this.GET_BY_ID = '/{id}';
        this.GET_LIST_FOR_PROJECT = '/list/project/{projectId}';
        this.UPDATE_TITLE = '/update/title';
        this.UPDATE_LIST_TYPE = '/update/list-type';
	}

	async getKaiziqManageConnectionById(id) {
		let url = window.location.origin + this.KAIZIQ_MANAGE + this.GET_BY_ID;
		url = url
			.replace('{id}', id);
		try {
			return this.fetch(url, {
				method: 'GET',
				retries: 10,
				retryDelay: 200
			}).then(data => data.json())
				.then(data => {
					if (data.error !== undefined) {
						if (data.error === 'Session Expired') {
							let userAuthService = new UserAuthService();
							userAuthService.logout();
						}
						else {
							localStorage.setItem('errorUUID', data.uuid);
						}
					}
					return data;
				})
		} catch (err) {
			console.log(err)
		}
	}

    async getKaiziqManageConnectionListByProject(projectId) {
		let url = window.location.origin + this.KAIZIQ_MANAGE + this.GET_LIST_FOR_PROJECT;
		url = url
			.replace('{projectId}', projectId);
		try {
			return this.fetch(url, {
				method: 'GET',
				retries: 10,
				retryDelay: 200
			}).then(data => data.json())
				.then(data => {
					if (data.error !== undefined) {
						if (data.error === 'Session Expired') {
							let userAuthService = new UserAuthService();
							userAuthService.logout();
						}
						else {
							localStorage.setItem('errorUUID', data.uuid);
						}
					}
					return data;
				})
		} catch (err) {
			console.log(err)
		}
	}

    async createKaiziqManageConnection(kaiziqManageConnection) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_MANAGE;
        try {
            return fetch(url, {
                method: 'POST',
                headers: {
                    'X-XSRF-TOKEN': csrfToken,
                },
                body: JSON.stringify(kaiziqManageConnection)
            }).then(data => data.json())
                .then(data => {
                    if (data.error !== undefined) {
                        if (data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch (err) {
            console.log(err)
        }
    }

    async updateKaiziqManageConnectionTitle(kaiziqManageConnectionId, newTitle) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_MANAGE;
        let body = {
            id: kaiziqManageConnectionId,
            title: newTitle
        }
        try {
            return fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken,
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if (data.error !== undefined) {
                        if (data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch (err) {
            console.log(err)
        }
    }

    async updateKaiziqManageConnectionListType(kaiziqManageConnectionId, newListType) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_MANAGE + this.UPDATE_LIST_TYPE;
        let body = {
            id: kaiziqManageConnectionId,
            listType: newListType
        }
        try {
            return fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken,
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if (data.error !== undefined) {
                        if (data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch (err) {
            console.log(err)
        }
    }

    async deleteKaiziqManageConnection(kaiziqManageConnectionId){
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_MANAGE;
        let body = {
            'id': kaiziqManageConnectionId
        };
        try {
            const dataRet = await this.fetch(url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return dataRet;
        } catch (err) {
            console.log(err);
        }
   }
}

export default KaiziqManageConnectionService;